/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
    
    export interface IBlockType {
        href: string;
        name: string;
        naturalKey: BlockTypeNaturalKey;
        pipePosition: string;
    }
    
    export class BlockType implements IBlockType {
        public static naturalKeyMap: { [key: string]: string } = {
            'MVP_CLIENT': 'Flex encoder',
            'MVP_SERVER': 'Flex server',
            'MVP_SERVER_TS': 'Flex server TS',
            'MVP_EXPORT': 'Flex export',
            'MVP_PLAYOUT': 'Flex receiver',
            'ATEME_DR5000': 'Ateme DR5000',
            'ERICSSON_RX8200': 'Ericsson RX8200',
            'IKUSNET_QUAD_TS': 'Ikusnet QUAD',
            'V_TS': 'Virtual TS',
            'SRT_GW_RX_LSTN': 'SRT GW RX Listener',
            'SRT_GW_TX_LSTN': 'SRT GW TX Listener',
            'V_TS_DESTINATION': 'Virtual TS Destination',
            'VIRT_SRT_TX_CALL': 'Virtual SRT TX Caller',
            'VIRT_SRT_RX_CALL': 'Virtual SRT RX Caller',
            'V_SDI': 'Virtual SDI',
            'MAKITO_X': 'Makito',
            'SRT_GW_TX_CALL': 'SRT GW TX Caller',
            'SRT_GW_RX_CALL': 'SRT GW RX Caller',
            'VIRT_SRT_RX_LSTN': 'Virtual SRT RX Listener',
            'VIRT_SRT_TX_LSTN': 'Virtual SRT TX Listener',
            'Intinor_DR': 'Intinor IP'
        };
        public name: string;
        public href: string;
        public naturalKey: BlockTypeNaturalKey;
        public pipePosition: string;

        public static Empty(): BlockType {
            return new BlockType();
        }

        constructor() {
            // empty constructor
            this.name = '';
        }
    }

    export class BlockTypeNaturalKey {
        public static MVP_CLIENT: string = "MVP_CLIENT";
        public static MVP_SERVER: string = "MVP_SERVER";
        public static MVP_SERVER_TS: string = "MVP_SERVER_TS";
        public static MVP_EXPORT: string = "MVP_EXPORT";
        public static MVP_PLAYOUT: string = "MVP_PLAYOUT";
        public static ATEME_DR5000: string = "ATEME_DR5000";
        public static ATEME_CM5000: string = "ATEME_CM5000";
        public static MEDIAKIND_RX8200: string = "MEDIAKIND_RX8200";
        public static IKUSNET_QUAD_TS: string = "IKUSNET_QUAD_TS";
        public static V_TS: string = "V_TS";
        public static SRT_GW_RX_LSTN: string = "SRT_GW_RX_LSTN";
        public static SRT_GW_TX_LSTN: string = "SRT_GW_TX_LSTN";
        public static T9261_D: string  = "T9261-D";
        public static SDI_DESTINATION: string = "V_SDI";
        public static V_TS_DESTINATION: string = "V_TS_DESTINATION";
        public static VIRT_SRT_RX_CALL: string = "VIRT_SRT_RX_CALL";
        public static VIRT_SRT_TX_CALL: string = "VIRT_SRT_TX_CALL";
        public static SRT_GW_TX_CALL: string = "SRT_GW_TX_CALL";
        public static SRT_GW_RX_CALL: string = "SRT_GW_RX_CALL";
        public static VIRT_SRT_RX_LSTN: string = "VIRT_SRT_RX_LSTN";
        public static VIRT_SRT_TX_LSTN: string = "VIRT_SRT_TX_LSTN";
        public static INTINOR: string = "Intinor";
        public static isPlayable(naturalKey: string): boolean {
            return naturalKey === this.VIRT_SRT_RX_CALL;
        }

        public static isSrtRx(naturalKey: string): boolean {
            return naturalKey === this.SRT_GW_RX_LSTN || naturalKey === this.SRT_GW_RX_CALL;
        }
    }
}
